import { isRouteErrorResponse, useLocation, useRouteError } from 'react-router'
import { AppErrWrap } from '#ui/Errors/AppErrWrap.tsx'
import { ErrorBody, RouteErrorBody } from '#ui/Errors/index.tsx'
import { WebsiteErrWrap } from '#ui/Errors/WebsiteErrWrap.tsx'

/**
 * This is a splat route, aka 404 route. It'll catch everything that was not
 * matched by any of the routes.
 */
export async function loader() {
  throw new Response('Not found', { status: 404 })
}

export default function NotFound() {
  // This comp will never be rendered because we catch it in the loader, but
  // it's good to return something here or remix shows a warning
  return <ErrorBoundary />
}

export function ErrorBoundary() {
  const error = useRouteError() as Error
  const isRouteError = isRouteErrorResponse(error)
  const { pathname } = useLocation()

  // Render different error comp if the user is using the app vs website
  if (pathname.startsWith('/app')) {
    return (
      <AppErrWrap>
        <RouteErrorBody error={error} />
      </AppErrWrap>
    )
  }

  return (
    <WebsiteErrWrap>
      {isRouteError ? (
        <RouteErrorBody error={error} />
      ) : (
        <ErrorBody error={error} />
      )}
    </WebsiteErrWrap>
  )
}
